import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, Subject, fromEvent } from 'rxjs';
import {
  MgLocation,
  LocationSearchResult,
  GenericViewItem,
  MapLocations,
  LocatorLabel,
  Who,
} from './../models/location.model';
import {
  config,
  getCountryConfig,
  getCountryConfig2,
} from '../config/country-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { catchError, map } from 'rxjs/operators';

import { EnvService } from './env.service';
import { LocationSearchRequest } from '../models/location.model';
import { defaultCountry } from '../store/service-options';
import { ClearSearchResultsAction, SetSearchLocationResultsAction } from '../store/locations/location.actions';
import { filterAndSortLocations } from '../store/locations/utils';

@Injectable({
  providedIn: 'root',
})
export class LocationFinderService {
  public country!: string;
  public labels: any = {};
  public filters: string[]
  public flow: string
  public countries: any[] = config;
  public locationsUnavailable: any = {};
  public isShowDetail: boolean = false;
  public searchResults!: any;
  // public searchResults!: LocationSearchResult; typscript 7053 error -need to fix
  // public searchQuery: LocationSearchQuery = {}; typscript 7053 error -need to fix
  public searchQuery: any = {};
  public orderedServices!: GenericViewItem[];
  public orderedFilters!: GenericViewItem[];
  public mapLocations: MapLocations[] = [];
  // public selectedBranch!: MgLocation;--need to fix typscript error
  public selectedBranch!: any;
  public selectedCountry: any;
  public locationLabels!: LocatorLabel;

  public searchCompleted = new BehaviorSubject<boolean>(false);
  public branchSelected = new BehaviorSubject<boolean>(false);
  private _selectedLocation$: BehaviorSubject<MgLocation | undefined> =
    new BehaviorSubject<MgLocation | undefined>(undefined);
  public readonly selectedLocation$: Observable<MgLocation | undefined> =
    this._selectedLocation$.asObservable();

  private hideSubject = new Subject<{ who: string; value: boolean }>();
  public hide$ = this.hideSubject.asObservable();

  public get selectedLocation() {
    return this._selectedLocation$.getValue();
  }

  public currentLocation: any;
  public weekDays: string[] = [
    'sunHours',
    'monHours',
    'tueHours',
    'wedHours',
    'thuHours',
    'friHours',
    'satHours',
  ];
  public dayNum: number = new Date().getDay();

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private store: Store
  ) {
    this.store.select(defaultCountry).subscribe((country) => {
      this.country = country;
      this.resetSearchQuery();
      this.resetSearchResults();
      this.selectedCountry =
        this.country.length > 2
          ? getCountryConfig(this.country)
          : getCountryConfig2(this.country);
    });
  }

  public getDefaultSelectedCountry(type: string, value?: string): any {
    if (this.countries.length) {
      switch (type) {
        case 'iso2Code':
          return this.countries.find((item) => item.iso2Code === value);
        case 'code':
          return this.countries.find((item) => item.code === value);
      }
    }
    return undefined;
  }

  public resetSelectedBranch(): void {
    this._selectedLocation$.next(undefined);
    this.selectedBranch = undefined;
  }

  public updateSelectedBranch(branch: MgLocation): void {
    this._selectedLocation$.next(branch);
    this.selectedBranch = branch;
  }

  public toggleBranchDetails(bool: boolean): void {
    this.isShowDetail = bool;
  }

  public resetSearchQuery(): void {
    this.searchQuery = {
      address: '',
      searchRadius: this.envService.searchRadius,
      limit: this.envService.searchLimit,
      country:
        this.country.length > 2
          ? getCountryConfig(this.country).iso2Code
          : getCountryConfig2(this.country).iso2Code,
      radiusuom: this.envService.radiusuom,
      agent: '',
      latitude: '',
      longitude: '',
      purpose: '',
      serviceOptions: '',
    };
  }

  public updateSelectedCountry(country: any): void {
    this.selectedCountry = country;
  }

  public updateSearchQuery(params: any): void {
    this.searchQuery = { ...this.searchQuery, ...params };

    if (!params.latitude || !params.longitude) {
      this.searchQuery.latitude = '';
      this.searchQuery.longitude = '';
    }
  }

  public resetSearchResults(): void {
    this.searchResults = undefined;
    this.mapLocations = [];
    this.searchCompleted.next(true);
  }
  public clearSearchResults(): void {
    this.searchResults = <LocationSearchResult>{};
  }

  public setDefaultAddress(newDefaultAddress: string) {
    this.searchQuery.address = newDefaultAddress;
  }
  public getDefaultAddress() {
    return this.searchQuery.address;
  }

  private buildReqObject(flow: string, additonalPayloadFxRate: any): LocationSearchRequest {
    const request = {
      address: this.searchQuery.address,
      latitude: this.searchQuery.latitude,
      longitude: this.searchQuery.longitude,
      searchRadius: this.searchQuery.searchRadius,
      limit: this.searchQuery.limit,
      country: this.searchQuery.country,
      radiusuom: this.searchQuery.radiusuom,
      agent: 'stellarcashout',
      ...additonalPayloadFxRate
    };
    if ([request.latitude, request.longitude].includes('')) {
      delete request.latitude;
      delete request.longitude;
    } else {
      delete request.address;
    }
    if (flow === 'withdraw') {
      return { ...request, agent: 'stellarcashout' };
    } else {
      return { ...request, agent: 'StellarStageSend', purpose: 'stageSend' };
    }
  }

  public searchLocationApi(flow:string, endpoint?:string, additonalPayloadFxRate?: any): Observable<any> { // TODO:TIM Update for endpoint v2/v3. TODO: endpoint not optional
    const reqObj: LocationSearchRequest = this.buildReqObject(flow, additonalPayloadFxRate);

    this.store.dispatch(ClearSearchResultsAction())

    const locationsUrl =
      endpoint === 'v3' // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
        ? `${this.envService.apiUrl}/v3/config-data/locations/fetch`
        : `${this.envService.apiUrl}/v2/config-data/locations/fetch`;

    return this.http.post(locationsUrl, reqObj).pipe(
      map((results: any) => {
        if (!this.filters || !this.labels || !this.flow) {
          return results;
        }
        const filteredResults = filterAndSortLocations(this.filters, results, this.labels, this.flow);
        this.searchResults = filteredResults ? filteredResults : {error: true};
        // this.generateLabels();
        this.generateMapLocations();
        this.store.dispatch(SetSearchLocationResultsAction({ searchResults: this.searchResults }))
        this.searchCompleted.next(true);
        return true;
      }),
      catchError((error) => {
        return of(error);
      })
    );
  }

  private generateMapLocations(): void {
    this.mapLocations = [];
    if (this.searchResults && !!this.searchResults.locations.length) {
      this.mapLocations = this.searchResults.locations.map(
        (location: {
          locationDetails: {
            locationId: any;
            name: any;
            latitude: any;
            longitude: any;
          };
        }) => ({
          locationId: location?.locationDetails?.locationId,
          name: location.locationDetails.name,
          latitude: location.locationDetails.latitude,
          longitude: location.locationDetails.longitude,
        })
      );
    }
  }

  // private generateLabels(): any {
  //   if (this.searchResults && this.searchResults.labels) {
  //     this.setLabels(this.searchResults.labels);
  //   } else if (this.locationLabels) {
  //     console.log('locationLabels', this.locationLabels)
  //     this.setLabels(this.locationLabels);
  //   }
  // }

  // private setLabels(labels: {}) {
  //   this.labels = Object.keys(labels).reduce((dict: any, key) => {
  //     const newKey = key.split('.').slice(2).join('.');
  //     dict[newKey] = labels[key];
  //     return dict;
  //   }, {});
  // }

  /*
    supports formatting addresses with the following optional props:
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'city',
    'state',
    'postalCode',
    'zipCode'
   */
  // loc: LocationDetail typscript 7053 error -need to fix
  public getFormattedAddress(loc: any): string {
    let retString = '';

    const propsToCheck = [
      'addressLine1',
      'addressLine2',
      'addressLine3',
      'city',
      'state',
      'postalCode',
      'zipCode',
    ];

    propsToCheck.forEach((prop: string) => {
      if (
        (loc.hasOwnProperty(prop) && !!loc[prop]) ||
        // for google location api, we get a postalCode back,
        // for TransactionDetails we get zip
        (prop === 'postalCode' && !!loc['zipCode'])
      ) {
        if (prop === 'postalCode') {
          retString += `${!!retString ? ' ' : ''}${
            String(loc[prop]).trim() || String(loc['zipCode']).trim()
          }`;
        } else if (prop !== 'zipCode') {
          retString += `${!!retString ? ' ' : ''}${String(loc[prop]).trim()}${
            prop === 'state' ? ',' : ''
          }`;
        }
      }
    });
    if (!retString) {
      console.warn('Could not format anything in `getFormattedAddress`');
    }
    return retString;
  }

  public extractLocationName(locationName: string): string {
    const locationNameIndexOfDash = locationName.indexOf('-');
    if (locationNameIndexOfDash !== -1) {
      return locationName.substring(0, locationNameIndexOfDash).trim();
    }
    return locationName.trim();
  }

  getMapSnapshotUrl(lat: string, lng: string): Observable<string | HTMLImageElement> {
    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7C${lat},${lng}&key=${this.envService.gmapKey}`
    return this.preloadImage(url)
  }

  private preloadImage(url:string): Observable<string | HTMLImageElement> {
    const img = new Image()
    img.src = url;
    return fromEvent(img, 'load').pipe(
      map(() => url),
      catchError(()=> '') //We can placeholder image if needed here.
    )
  }

  public getUnavailable(locationId: string | number): string | undefined {
    return (
      this.locationsUnavailable[locationId] &&
      this.locationsUnavailable[locationId].message
    );
  }

  public hide(who: Who, value: boolean) {
    this.hideSubject.next({ who, value });
  }
}
